import { Loader, Modal } from '../../../../../shared/ui';

type Props = {
  isOpen: boolean;
  onClose(): void;
};

export const SharePageModalPlaceholder: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      isShowCancelButton={false}
      className="!w-160 sm:!w-full !p-0 relative h-180"
    >
      <div className="flex items-center justify-center h-full">
        <Loader />
      </div>
    </Modal>
  );
};
